enum ChatTypes {
    SET_UNREAD_CHATS = 'SET_UNREAD_CHATS',
    SET_SELECTED_CHAT = 'SET_SELECTED_CHAT',
    CLEAR_UNREAD = 'CLEAR_UNREAD',
    ADD_CHAT_CONNECTION = 'ADD_CHAT_CONNECTION',
    END_CHAT = 'END_CHAT',
    REMOVE_CHAT_CONNECTION = 'REMOVE_CHAT_CONNECTION',
    CLEAR_CHAT_CONNECTION = 'CLEAR_CHAT_CONNECTION',
    CHAT_CONNECTED = 'CHAT_CONNECCTED',
    CHAT_DISCONNECTED = 'CHAT_DISCONNECTED',
    CHAT_ACW = 'CHAT_ACW',
    CHAT_ACW_EXTEND = 'CHAT_ACW_EXTEND',
    CHAT_MISSED = 'CHAT_MISSED',
    RECIEVE_CHAT_MESSAGE = 'RECIEVE_CHAT_MESSAGE',
    SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE',
    ACCEPT_CHAT = 'ACCEPT_CHAT',
    DECLINE_CHAT = 'DECLINE_CHAT',
    COMPLETE_CHAT_ACW = 'COMPLETE_CHAT_ACW',
    RECOVER_CHATS = 'RECOVER_CHATS',
    CHAT_CONTACT_IS_TYPING = 'CHAT_CONTACT_IS_TYPING',
    CHAT_SEND_TYPING_EVENT = 'CHAT_SEND_TYPING_EVENT',
    TRANSFER_CHAT = 'TRANSFER_CHAT',
    MARK_CHAT_MESSAGE_RECEIPTS_AS_READ = 'MARK_CHAT_MESSAGE_RECEIPTS_AS_READ',
    GET_QUICK_REPLIES = 'GET_QUICK_REPLIES',
    GET_QUICK_REPLIES_LOADING = 'GET_QUICK_REPLIES_LOADING',
    SET_QUICK_REPLIES_CHANNELS = 'SET_QUICK_REPLIES_CHANNELS',
    UPDATE_DPA_CHAT = 'UPDATE_DPA_CHAT',
    UPDATE_DPA_RESULT_CHAT = 'UPDATE_DPA_RESULT_CHAT',
    UPDATE_AGENT_DPA_CHAT = 'UPDATE_AGENT_DPA_CHAT',
    SET_CHAT_REPLY_TEXT = 'SET_CHAT_REPLY_TEXT',
    UPDATE_NOTE = 'UPDATE_NOTE',
    UPDATE_CONNECTION_EDITOR_CONTENT = 'UPDATE_CONNECTION_EDITOR_CONTENT',
    DOWNLOAD_ATTACHMENT = 'DOWNLOAD_ATTACHMENT',
    DOWNLOAD_CONNECT_ATTACHMENT_FROM_TRANSCRIPT = 'DOWNLOAD_CONNECT_ATTACHMENT_FROM_TRANSCRIPT',
    SEND_ATTACHMENT = 'SEND_CHAT_ATTACHMENT',
    SET_ATTACHMENT = 'SET_CHAT_ATTACHMENT',
    DELETE_ATTACHMENT = 'DELETE_CHAT_ATTACHEMENT',
    SET_ATTACHMENT_LOADING = 'SET_CHAT_ATTACHMENT_LOADING',
    SET_CUSTOMER_INITIALLY_ACTIVE = 'SET_CUSTOMER_INITIALLY_ACTIVE',
    SET_DELIVERED_TIMESTAMP = 'SET_DELIVERED_TIMESTAMP',
    SET_READ_TIMESTAMP = 'SET_READ_TIMESTAMP'
}

export default ChatTypes;